import React from "react";
// import React, {useContext,useEffect } from "react";
import "./Home.css";
import Banner from "../Banner/Banner";

import CardList from "../CardList/CardList";

function Home(props) {
  const lang = props.lang;

  //BOTÓN VER MÁS OBRAS POR AHORA NO
  // const handleClick = () => {
  //   props.handleFilter(""); //si hay un filtro lo borrará...
  // };
  //eti idiomas
  // let more = "";
  // if (lang === "cat") {
  //   more = "Veure totes les obres";
  // }
  // if (lang === "esp") {
  //   more = "Ver todas las obras";
  // }
  // if (lang === "eng") {
  //   more = "View more";
  // }
  return (
   
    <div className="home">
      {<Banner lang={lang} />}
      <section className="home__section">
        <CardList lang={lang} assets={props.assets} />
      </section>
      {/* <div onClick={handleClick} className="home__button">
        {more}
      </div> */}
    </div>
    
  );
}

export default Home;
